// Module
var code = `<div class="logged_out sessions"><sign-in-form show-forgot-password="false"></sign-in-form></div>`;
// Exports
export default code;